// src/components/SolarServices.js
import React, { useState } from 'react';
import '../../../styles/CustomerSiteStyles/SolarServices.css';
import { useNavigate } from 'react-router-dom';

function SolarServices() {
  const solarComponents = [
    {
      title: 'Jinko Eagle Continental Panels 380W',
      description:
        'We use high-efficiency Jinko Eagle Continental Panels rated at 380W. These panels are known for their durability and excellent performance, even in low-light conditions. They maximize energy production to ensure you get the most out of your solar system.',
    },
    {
      title: 'Duracell or Enphase Microinverters',
      description:
        'Our systems utilize Duracell or Enphase microinverters, which convert the DC power generated by the solar panels into usable AC power for your home. Microinverters increase system efficiency and offer greater flexibility and reliability compared to traditional inverters.',
    },
    {
      title: 'Energy Storage Solutions',
      description:
        "Pair your solar panels with Duracell or Enphase storage batteries to store excess energy generated during the day. This allows you to use solar power even when the sun isn't shining, providing backup power during outages and further reducing your reliance on the grid.",
    },
    {
      title: 'Accessory Components',
      description:
        'We offer a range of accessory components to enhance your solar system, including mounting hardware, monitoring systems, and more. Our team ensures every part of your solar installation is optimized for performance and longevity.',
    },
  ];

  const navigate = useNavigate();
  const handleContactNav = () => {
    navigate('/contact');
  };

  return (
    <div className="solar-container">
      {/* Hero Section with Parallax Effect */}
      <section className="solar-hero">
        <div className="solar-overlay">
          <div className="solar-content">
            <h1>Harness the Power of the Sun</h1>
            <p>Innovative Solar Solutions for Your Home</p>
            <button onClick={handleContactNav} className="solar-button">Get a Solar Quote</button>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="solar-intro-section">
        <div className="solar-intro-content">
          <h2>Why Go Solar?</h2>
          <div className="solar-benefits">
            <div className="benefit-card">
              <h3>Energy Savings</h3>
              <p>Generate your own electricity and dramatically reduce your monthly utility bills while protecting yourself from rising energy costs.</p>
            </div>
            <div className="benefit-card">
              <h3>Increased Home Value</h3>
              <p>Studies show that homes with solar systems sell for more than homes without them, making solar a sound investment for your property.</p>
            </div>
            <div className="benefit-card">
              <h3>Environmental Impact</h3>
              <p>Reduce your carbon footprint by generating clean, renewable energy that doesn't contribute to greenhouse gas emissions or pollution.</p>
            </div>
            <div className="benefit-card">
              <h3>Energy Independence</h3>
              <p>With battery storage options, you can reduce your reliance on the grid and maintain power even during outages or emergencies.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Components and Video Section */}
      <section className="solar-system-section">
        <div className="solar-system-container">
          {/* Solar Components */}
          <div className="solar-components">
            <h2>Our Premium Solar Components</h2>
            <p className="components-intro">We use only high-quality, industry-leading components in our solar installations to ensure maximum performance and longevity.</p>
            
            <div className="components-list">
              {solarComponents.map((component, index) => (
                <ComponentItem key={index} component={component} />
              ))}
            </div>
          </div>

          {/* Video Section */}
          <div className="solar-video">
            <div className="video-content">
              <h2>Learn More About the Enphase Home Energy Solution</h2>
              <div className="video-wrapper">
                <iframe
                  src="https://www.youtube.com/embed/cmvacfke1mY"
                  title="Enphase Home Energy Solution"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section className="solar-cta-section">
        <div className="solar-cta-content">
          <h2>Ready to Embrace Solar Energy?</h2>
          <p>Contact us today for a free consultation and discover how our solar solutions can benefit your home and the environment.</p>
          <button onClick={handleContactNav} className="solar-cta-button">Contact Our Team</button>
        </div>
      </section>
    </div>
  );
}

// Component Item
function ComponentItem({ component }) {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="component-list-item">
      <div className="component-list-header" onClick={toggleExpand}>
        <div className="component-list-title">
          <h3>{component.title}</h3>
        </div>
        <span className="toggle-symbol">{expanded ? '−' : '+'}</span>
      </div>
      
      {expanded && (
        <div className="component-list-content">
          <p>{component.description}</p>
        </div>
      )}
    </div>
  );
}

export default SolarServices;